import { SHARED_SLICE_MODEL_FILENAME } from "./constants.js";
import { writeSliceFile } from "./writeSliceFile.js";
const writeSliceModel = async (args) => {
  return await writeSliceFile({
    ...args,
    filename: SHARED_SLICE_MODEL_FILENAME,
    contents: JSON.stringify(args.model, null, 2)
  });
};
export {
  writeSliceModel
};
//# sourceMappingURL=writeSliceModel.js.map
